import React, { ComponentType, FC } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Subtract } from 'utility-types';

import { ClientGroupSource, GetGroupSourcesComponent } from 'api';
import { QueryManager } from 'components';
import { IMatchParams } from 'features/groups/types';

export interface IWithGroupSources {
  groupSources: ClientGroupSource[];
}

type ComponentProps<T> = T & RouteComponentProps<IMatchParams>;

const withGroupSources = <T extends IWithGroupSources>(ChildComponent: ComponentType<T>) => {
  type Props = Subtract<T, IWithGroupSources> & RouteComponentProps<IMatchParams>;

  const WithGroupSources: FC<Props> = props => {
    const { match } = props;
    const { group_id } = match.params;

    return (
      <GetGroupSourcesComponent fetchPolicy="network-only" variables={{ group_id }}>
        {queryResult => (
          <QueryManager {...queryResult}>
            {() => (
              <ChildComponent
                {...(props as ComponentProps<T>)}
                groupSources={queryResult.data.getClientGroupSourcesByGroup}
              />
            )}
          </QueryManager>
        )}
      </GetGroupSourcesComponent>
    );
  };

  return withRouter(WithGroupSources);
};

export default withGroupSources;
